import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-deamb',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-deamb.component.html',
  styleUrl: './traitement-data-deamb.component.scss',
})
export class TraitementDataDeambComponent {
  @Input() patient: Patient | undefined;
}
